import { Button, Layout, Select } from 'antd';
import * as React from 'react';
import { withRouter, Switch } from 'react-router-dom';

import GetUserQuery from '../Query/Users/User';
import Attributes from '../../scenes/Attributes';
import Catalog from '../../scenes/Catalog';
import Categories from '../../scenes/Categories';
import Currencies from '../../scenes/Currencies';
import Customers from '../../scenes/Customers';
import CustomerGroups from '../../scenes/CustomerGroup';
import Dashboard from '../../scenes/Dashboard';
import DeliveryMethods from '../../scenes/DeliveryMethods';
import Languages from '../../scenes/Languages';
import Manufacturers from '../../scenes/Manufacturers';
import Orders from '../../scenes/Orders';
import OrderView from '../../scenes/OrderView';
import PaymentMethods from '../../scenes/PaymentMethods';
import Products from '../../scenes/Products';
import Suppliers from '../../scenes/Suppliers';
import VoucherGroupsTable from '../../scenes/VoucherGroups';
import StaticVoucherGroupsTable from '../../scenes/StaticVoucherGroups';
import VouchersTable from '../../scenes/Vouchers';
import Eshops from '../Query/Eshops';
import AppFooter from './AppFooter';
import AppNavigation from './AppNavigation';
import ProtectedRoute from './ProtectedRoute';
import OrderStatesTable from '../../scenes/OrderStates';
import LetterData from '../../scenes/LetterData';
import StaticDocumentsTable from '../../scenes/StaticDocuments/';
import BannersTable from '../../scenes/Banners/';
import StoresTable from '../../scenes/Stores';
import NotFound from '../../scenes/NotFound';
import ProductTag from '../../scenes/ProductTag';
import Availabilities from '../../scenes/Availabilities';
import Countries from '../../scenes/Countries';
import Users from '../../scenes/Users';
import Business from '../../scenes/Business';
import AuthService from '../../services/AuthService';
import VouchersImportExport from '../../scenes/VouchersImportExport';
import VouchersGenerateRandom from '../../scenes/VouchersGenerateRandom';

const { Content, Sider, Header } = Layout;

class AppContent extends React.Component {

  state = {
    collapsed: false
  };

  constructor(props: any) {
    super(props);
    this.onCollapse = this.onCollapse.bind(this);
  }

  public render() {
    return (
      <GetUserQuery>
        {({ loggedIn }: any) => {

          if (loggedIn && !loggedIn.loading && loggedIn.loggedIn && loggedIn.loggedIn.user) {
            AuthService.GetInstance().setLoggedUser(loggedIn.loggedIn.user);
          }

          return (
            <Layout>
              <Sider
                style={{
                  overflow: 'auto',
                  height: '100vh',
                  position: 'fixed',
                  left: 0
                }}
                collapsible={true}
                collapsed={this.state.collapsed}
                onCollapse={this.onCollapse}
              >
                <AppNavigation />
              </Sider>
              <Layout>
                <Header style={{ background: '#fff', paddingRight: '14px' }}>
                  <div
                    style={{
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    <div style={{ padding: '5px' }}>
                      <Eshops>
                        {({ eshops }: any) => {
                          if (eshops && eshops.loading) {
                            return <span>loading...</span>;
                          }

                          if (eshops && eshops.eshops) {
                            return (
                              <Select
                                value={(this.props as any).match.params.eshop}
                                placeholder={'Current eshop'}
                                style={{ minWidth: '140px' }}
                                onChange={e => (window.location.href = `/${e}/application/dashboard`)}
                              >
                                {eshops.eshops.map((e: GQL.IEshop) => {
                                  return (
                                    <Select.Option key={e.id} value={e.domain}>
                                      {e.name}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            );
                          }

                          return null;
                        }}
                      </Eshops>
                    </div>
                    <div style={{ padding: '5px' }}>
                      <Button onClick={() => this.logout()} style={{ minWidth: '50px' }}>
                        Logout
                      </Button>
                    </div>
                  </div>
                </Header>

                <Content
                  style={{
                    marginLeft: this.state.collapsed ? 80 : 200,
                    padding: '16px',
                    minHeight: 'calc(100vh - 134px)'
                  }}
                >
                  <div
                    style={{
                      background: '#fff',
                      padding: 24,
                    }}
                  >
                    <Switch>
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/dashboard"
                        exact={false}
                        component={Dashboard}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/products"
                        component={Products}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/product-tags/:productTagId?"
                        component={ProductTag}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/availabilities/:availabilityId?"
                        component={Availabilities}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/category/:categoryId?/:parentCategoryId?"
                        exact={false}
                        onCollapse={this.onCollapse}
                        component={Categories}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/attributes/:attributeId?"
                        exact={false}
                        onCollapse={this.onCollapse}
                        component={Attributes}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/orders"
                        exact={true}
                        component={Orders}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/orders/:customerId"
                        exact={true}
                        component={Orders}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/customers/:customerId?"
                        exact={false}
                        component={Customers}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/customerGroup/:groupId?"
                        exact={false}
                        component={CustomerGroups}
                      />
                      <ProtectedRoute
                        onCollapse={this.onCollapse}
                        path="/:eshop/application/order/:orderId"
                        exact={false}
                        component={OrderView}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/countries/:countryId?"
                        onCollapse={this.onCollapse}
                        exact={false}
                        component={Countries}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/languages"
                        onCollapse={this.onCollapse}
                        exact={false}
                        component={Languages}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/currency/:currencyId?"
                        onCollapse={this.onCollapse}
                        exact={false}
                        component={Currencies}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/suppliers"
                        onCollapse={this.onCollapse}
                        exact={false}
                        component={Suppliers}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/manufacturers"
                        exact={false}
                        component={Manufacturers}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/paymentMethods/:paymentMethodId?"
                        exact={false}
                        component={PaymentMethods}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/deliveryMethods/:deliveryMethodId?"
                        exact={false}
                        component={DeliveryMethods}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/order-state/:orderStateId?"
                        exact={false}
                        component={OrderStatesTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/letter-data/:letterDataId?"
                        exact={false}
                        component={LetterData}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/business/:businessId?"
                        exact={false}
                        component={Business}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/vouchers"
                        exact={true}
                        component={VoucherGroupsTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/import-export-vouchers/:groupId?"
                        exact={true}
                        component={VouchersImportExport}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/generate-random-vouchers/:groupId?"
                        exact={true}
                        component={VouchersGenerateRandom}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/static-vouchers/:groupId?"
                        exact={true}
                        component={StaticVoucherGroupsTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/stores"
                        exact={true}
                        component={StoresTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/store/:storeId?"
                        exact={true}
                        component={StoresTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/static-documents"
                        exact={true}
                        component={StaticDocumentsTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/vouchers/:voucherGroup"
                        exact={true}
                        component={VouchersTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/catalog/:categoryId?"
                        component={Catalog}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/banners/:bannerId?"
                        exact={true}
                        component={BannersTable}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/application/account/:userId?"
                        exact={true}
                        component={Users}
                        onCollapse={this.onCollapse}
                      />
                      <ProtectedRoute
                        path="/:eshop/*"
                        exact={true}
                        component={NotFound}
                        onCollapse={this.onCollapse}
                      />
                    </Switch>
                  </div>
                </Content>
                <AppFooter
                  style={{ marginLeft: this.state.collapsed ? 80 : 200 }}
                />
              </Layout>
            </Layout>
          );
        }}
      </GetUserQuery>
    );
  }

  private logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.reload();
  }

  private onCollapse(collapsed: boolean) {
    this.setState({ collapsed });
  }
}

export default withRouter(AppContent);



// WEBPACK FOOTER //
// ./src/components/Layout/AppContent.tsx